import * as Icons from "heroicons-react";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  useCountSupplierQuery,
  useDeleteSupplierMutation,
  useSupplierPagenationQuery,
} from "../../services/supplierApi";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import "./Supplier.css";

const Supplier = () => {
  const auth = signInUser();
  const { aamarId } = auth;
  //   const { data } = useSuppliersQuery();
  const [deleteSupplier] = useDeleteSupplierMutation();
  // get totel product count
  const pageCountQuery = useCountSupplierQuery();
  const lang = useSelector((state) => state.languageReducer);

  const [pageCount, setPageCount] = useState(0);
  const [pageNo, setPageNo] = useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(100);
  const [q, setQ] = useState("");

  const [loader, setLoader] = useState(true);
  const handleLoaderClose = () => setLoader(false);

  const { data, error, isLoading, isFetching, isSuccess, refetch } =
    useSupplierPagenationQuery({
      page,
      size,
      aamarId,
      q,
    });
  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data]);
  // console.log(data);

  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    const { data } = pageCountQuery;
    setPageCount(data);
  }, [pageCountQuery]);

  const deleteHandler = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you Sure?",
        text: "Delete this Supplier?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        setLoader(true);
        const res = await deleteSupplier(id);
        if (res) {
          // TODO::
          // add error hendaler for delete error
          console.log(res);
          Swal.fire("Deleted!", "Supplier has been deleted.", "success");
        } else {
          console.log("Delete Operation Canceled by Supplier!");
          return;
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  };

  const handlePageClick = (data) => {
    setPage(parseInt(data.selected));
    setPageNo(getPageNumber);
  };

  const handleDataLimit = (e) => {
    setSize(parseInt(e.target.value));
    setPageNo(getPageNumber);
  };

  const handleSearch = (e) => {
    setQ(e.target.value);
    refetch();
  };

  const getPageNumber = () => {
    const cont = Math.ceil(parseInt(pageCount) / parseInt(size));
  };

  let i = 1;

  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.supplier}></Header>
            <div className="row">
              <div className="col-md-6 mt-4">
                <form>
                  <div className="input-group mb-3">
                    <select
                      className="form-select"
                      onChange={(e) => handleDataLimit(e)}
                    >
                      <option value="100">100</option>
                      <option value="150">150</option>
                      <option value="200">200</option>
                      <option value="250">250</option>
                    </select>
                    <input
                      className="form-control ms-2"
                      type="text"
                      onKeyUp={(e) => handleSearch(e)}
                    />
                    {/* <input type="text" className="form-control" aria-label="Text input with dropdown button"> */}
                  </div>
                </form>

                <nav aria-label="Page navigation example">
                  <ReactPaginate
                    previousLabel={"<<"}
                    nextLabel={">>"}
                    breakLabel={"..."}
                    //dynamic page count
                    // page count total product / size
                    pageCount={Math.ceil(parseInt(pageCount) / parseInt(size))}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={6}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination pt-0 pb-2"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                  ></ReactPaginate>
                </nav>
              </div>

              <div className="col-md-6 mt-md-2 mb-2">
                <div className="float-end">
                  <Link
                    to="/create-supplier"
                    className="float-end btn btn-dark "
                  >
                    {lang?.createSupplier || "Create Supplier"}
                  </Link>

                  <Link
                    className="btn btn-dark mb-2 float-end me-2 "
                    to="/supplier/importSupplier"
                  >
                    <Icons.PlusOutline size={22}></Icons.PlusOutline>{" "}
                    {lang?.importSupplier || "Import Supplier"}
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              {/* <div className="col-md-12">
                <Link
                  to="/create-supplier"
                  className="float-end btn btn-dark my-3"
                >
                  Create Supplier
                </Link>
              </div> */}
              <div className="col-md-12">
                <div
                  className="table-responsive"
                  // style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  <table className="table table-striped ">
                    <thead>
                      <tr>
                        {/* <th scope="col">#</th> */}
                        <th scope="col">Code</th>
                        <th scope="col">Company</th>
                        <th scope="col">Supplier</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone</th>
                        {/* <th scope="col">Address</th> */}
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.length > 0 ? (
                        data?.map((supplier) => (
                          <tr key={supplier._id}>
                            {/* <th scope="row">{i++}</th> */}
                            <th scope="row">{supplier.code}</th>
                            <td>
                              {supplier.company
                                ? supplier.company
                                : "No Company"}
                            </td>
                            <td>{supplier.name}</td>
                            <td>{supplier.email}</td>
                            <td>
                              {supplier.phone ? supplier.phone : "No Phone"}
                            </td>
                            {/* <td>{supplier?.address}</td> */}
                            <td>
                              <Link to={`/supplier-ledger/${supplier._id}`}>
                                <Icons.DocumentTextOutline
                                  className="icon-edit"
                                  size={20}
                                ></Icons.DocumentTextOutline>
                              </Link>
                              <Link to={`/update-supplier/${supplier._id}`}>
                                <Icons.PencilAltOutline
                                  className="icon-edit"
                                  size={20}
                                ></Icons.PencilAltOutline>
                              </Link>
                              {auth?.type === "admin" && (
                                <Icons.TrashOutline
                                  className="icon-trash"
                                  onClick={() => deleteHandler(supplier._id)}
                                  size={20}
                                />
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center">
                            No Supplier Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default Supplier;
